import { styled } from "styled-components";

export const PersonalBarContainer = styled.div`
  width: 100%;
  height: 150px;
  border-left: 2px solid black;
  border-right: 2px solid black;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  font-size: 24px;
  font-weight: 600;
`;
